// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-filter-content .sub-filter-list {
  max-height: 200px;
  overflow-y: auto;
  background-color: transparent;
}

.filter {
  margin-top: 3px;
  font-size: 17px;
  font-weight: medium;
  color: #000;
  float: left;
  margin-bottom: 18px;
  background-color: #f6f6f6;
  width: 100%;
  padding: 0 15px;
}

.sortby_dropdown {
  background-color: #fff;
  border: 1px solid #aaa;
  font-size: 13px;
  color: #000;
  padding: 9px;
  width: 100%;
}

.form-group-sort {
  margin-top: 80px;
  font-weight: medium;
  color: #000;
  padding-left: 12px;
  vertical-align: center;
  text-align: left;
}

.filter_list {
  font-size: 13px;
  font-weight: regular;
  color: #000;
  padding-left: 12px;
  vertical-align: center;
  text-align: left;
}

.filter_checkbox {
  height: 15px;
  width: 15px;
  border: 1px solid #aaa;
  margin-bottom: 10px;
}

.if_checked {
  background-color: #202425;
}

.slider {
  background-color: #b4cbd4;
  width: 170px;
  height: 2.5px;
}

.slider_circle {
  background-color: #7ba7b7;
  height: 9px;
  width: 9px;
}

.slider_text {
  font-size: 13px;
  color: #000;
  font-weight: light;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/pages/company/companyFilter.scss"],"names":[],"mappings":"AACI;EACI,iBAAA;EACA,gBAAA;EACA,6BAAA;AAAR;;AAMA;EACI,eAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;AAHJ;;AAMA;EACI,sBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAHJ;;AAMA;EACI,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,eAAA;EACA,oBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,YAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,yBAAA;AAHJ;;AAMA;EACI,yBAAA;EACA,YAAA;EACA,aAAA;AAHJ;;AAMA;EACI,yBAAA;EACA,WAAA;EACA,UAAA;AAHJ;;AAMA;EACI,eAAA;EACA,WAAA;EACA,kBAAA;AAHJ","sourcesContent":[".company-filter-content {\n    .sub-filter-list {\n        max-height: 200px;\n        overflow-y: auto;\n        background-color: transparent;\n    }\n}\n// .col {\n//     margin-left: -20px;\n// }\n.filter {\n    margin-top: 3px;\n    font-size: 17px;\n    font-weight: medium;\n    color: #000;\n    float: left;\n    margin-bottom: 18px;\n    background-color: #f6f6f6;\n    width: 100%;\n    padding: 0 15px;\n}\n\n.sortby_dropdown {\n    background-color: #fff;\n    border: 1px solid #aaa;\n    font-size: 13px;\n    color: #000;\n    padding: 9px;\n    width: 100%;\n}\n\n.form-group-sort {\n    margin-top: 80px;\n    font-weight: medium;\n    color: #000;\n    padding-left: 12px;\n    vertical-align: center;\n    text-align: left;\n}\n\n.filter_list {\n    font-size: 13px;\n    font-weight: regular;\n    color: #000;\n    padding-left: 12px;\n    vertical-align: center;\n    text-align: left;\n}\n\n.filter_checkbox {\n    height: 15px;\n    width: 15px;\n    border: 1px solid #aaa;\n    margin-bottom: 10px;\n}\n\n.if_checked {\n    background-color: #202425;\n}\n\n.slider {\n    background-color: #b4cbd4;\n    width: 170px;\n    height: 2.5px;\n}\n\n.slider_circle {\n    background-color: #7ba7b7;\n    height: 9px;\n    width: 9px;\n}\n\n.slider_text {\n    font-size: 13px;\n    color: #000;\n    font-weight: light;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
